import { render, staticRenderFns } from "./modifyPwd.vue?vue&type=template&id=3a6cbcca&scoped=true"
import script from "./modifyPwd.vue?vue&type=script&lang=js"
export * from "./modifyPwd.vue?vue&type=script&lang=js"
import style0 from "./modifyPwd.vue?vue&type=style&index=0&id=3a6cbcca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6cbcca",
  null
  
)

export default component.exports